module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dPOdF"))).then(() => parcelRequire('d0iPb'));